import { Component, computed, EventEmitter, input, Input, InputSignal, Output, Signal, signal } from '@angular/core';
import _ from 'lodash';
import { BehaviorSubject } from 'rxjs';
import { SortColumn } from 'src/app/models/sortColumn.model';
import { ViolationRulesTableColumns } from 'src/app/models/tableColumns/violationRulesColumns.model';
import { ViolationRulesViewModel } from 'src/app/models/viewModels/violationRulesViewModel';
import { RowActionClicked } from '../table-row/table-row.component';

@Component({
  selector: 'app-violation-rules-table',
  templateUrl: './violation-rules-table.component.html',
  styleUrls: ['./violation-rules-table.component.scss'],
})
export class ViolationRulesTableComponent {
  public isLoading = input<boolean>(false);

  currentRulesViewModel: InputSignal<BehaviorSubject<BehaviorSubject<ViolationRulesViewModel>[]>> = input.required();

  @Input() public categoryDisplayName?: string;
  @Input() public categoryCode?: string;
  @Input() public categoryLink?: string;

  @Output() public rowActionOnClick = new EventEmitter<RowActionClicked>();

  public tableData: Signal<BehaviorSubject<BehaviorSubject<ViolationRulesViewModel>[]>>;
  public tableColumns = ViolationRulesTableColumns;
  public sortedColumn = signal<SortColumn | undefined>(undefined);
  public sorting: Signal<{ sorting: 'violations' | 'severity'; isDesc: boolean } | null>;
  public isEmptyTable: Signal<boolean>;

  constructor() {
    this.tableData = computed(() => {
      const sort = this.sorting();
      if (!sort) {
        return this.currentRulesViewModel();
      }

      const isDescStr = sort.isDesc ? 'desc' : 'asc';
      switch (sort.sorting) {
        case 'violations':
          return new BehaviorSubject(_.orderBy(this.currentRulesViewModel().value, ['value.violations'], [isDescStr]));
        case 'severity':
          return new BehaviorSubject(
            _.orderBy(this.currentRulesViewModel().value, ['value.severityValue'], [isDescStr])
          );
      }
    });

    this.isEmptyTable = computed(() => !this.tableData().value.length);

    this.sorting = computed(() => {
      const sort = this.sortedColumn();
      if (!sort) return null;

      if (sort.column.sortKey === 'violations') {
        return { sorting: 'violations', isDesc: sort.isDesc };
      } else if (sort.column.sortKey === 'severity') {
        return { sorting: 'severity', isDesc: sort.isDesc };
      }

      return null;
    });
  }

  public actionOnClick(actionClicked: RowActionClicked): void {
    this.rowActionOnClick.emit(actionClicked);
  }

  //Update Sorting (called from Child)
  public onSortedColumnChange(newSortColumn: SortColumn): void {
    this.sortedColumn.set(newSortColumn);
  }
}
